export enum StateCategory {
  Unknown = 0,
  Category1 = 1,
  Category2 = 2,
}

const categoryDefinitions: Record<StateCategory, string[]> = {
  [StateCategory.Unknown]: [],
  [StateCategory.Category1]: [
    "AL", "AK", "AR", "CO", "GA", "HI", "ID", "IL", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "NE", "NV", "NH", "NM", "NC", "OH", "OK", "OR", "PA",
    "RI", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ],
  [StateCategory.Category2]: [
    "AZ", "CT", "DE", "DC", "FL", "IN", "MT", "NJ", "ND", "SC", "SD"
  ],
};

const stateToUSAStateCategory: Record<string, StateCategory> = {};

Object.entries(categoryDefinitions).forEach(([categoryStr, states]) => {
  const category = Number(categoryStr) as StateCategory;
  states.forEach(state => {
    stateToUSAStateCategory[state] = category;
  });
});

export const stateToStateCategory = (state: string): StateCategory => {
  return stateToUSAStateCategory[state] || StateCategory.Unknown;
};
